import { benefitsData } from '../entity/benefitsData.jsx';

/**
 * Interactor (Business Logic) for Benefits Section
 * Handles data retrieval and processing for benefits
 */
export const useBenefitsInteractor = () => {
  const getBenefits = () => {
    // In a real app, this might fetch from an API
    return benefitsData;
  };

  return {
    benefits: getBenefits(),
  };
};
